import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
export default new VueRouter({
    routes: [
        { path: '/', name: 'home', component: () => import('@/pages/Home.vue') },
        { path: '/about-us', name: 'about-us', component: () => import('@/pages/AboutUs.vue') },
        { path: '/privacy-policy', name: 'privacy-policy', component: () => import('@/pages/PrivacyPolicy.vue') }, 
        { path: '/terms-and-conditions', name: 'terms-and-conditions', component: () => import('@/pages/TermsAndConditions.vue') }, 
    ],
    mode: 'history',
    scrollBehavior: () => ({ left: 0, top: 0 })
})